/**
 * Combines one or more QuestionExtension factories into a single component
 * so gap notices and AI suggestions can render on the same question.
 *
 * @param {...(Function|null|undefined)} extensions
 * @returns {Function|null}
 */
export const composeQuestionExtensions = (...extensions) => {
    const active = extensions.filter(Boolean);

    if (active.length === 0) {
        return null;
    }

    if (active.length === 1) {
        return active[0];
    }

    const ComposedQuestionExtension = (props) => (
        <>
            {active.map((Extension, index) => (
                <Extension key={index} {...props} />
            ))}
        </>
    );

    ComposedQuestionExtension.displayName = "ComposedQuestionExtension";

    return ComposedQuestionExtension;
};

export default composeQuestionExtensions;
